// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, OnInit, Input,  OnChanges, SimpleChanges } from '@angular/core';
import { D3eService } from 'src/services/d3e-service';
import { IDeviceSetBare } from 'src/types/device-sets';
import { TopNType } from '../dashboard.types';
import { SelectedOrgMethod } from 'src/shared/selectedOrg';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-top-n-devices',
    templateUrl: './top.n.devices.component.html',
    styleUrls: ['./top.n.devices.component.scss', '../component.common.scss'],
    standalone: false
})

export class TopNDevicesComponent implements OnInit, OnChanges {
  @Input() timeInterval: string;
  @Input() deviceSet: IDeviceSetBare;
  @Input() refreshTrigger: number;
  @Input() selectedOrgId: string;

  topNList: TopNType[] = null;

  headerTopNList = '';

  fThreatsTitle: string;
  fThreatsNone: string;
  constructor(
    private d3eService: D3eService,
    private translate: TranslateService
  ) {
      this.translate.get(['DASH_TET_TITLE', 'DASH_TET_NONE']).subscribe(vals => {
          this.fThreatsTitle = vals['DASH_TET_TITLE'];
          this.fThreatsNone = vals['DASH_TET_NONE'];
      });
  }

  ngOnInit() {
    // do not load until device set list has been retrieved and set
//    this.getTopNDevices();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ( changes.deviceSet !== undefined ) {
      this.deviceSet = changes.deviceSet.currentValue;
    } 

    if ( changes.selectedOrgId !== undefined ) {
      this.selectedOrgId = changes.selectedOrgId.currentValue;
      if (this.refreshTrigger == null) {
          this.getTopNDevices();
      }
    }

    if ( changes.refreshTrigger !== undefined && changes.refreshTrigger.firstChange === false) {
      this.refreshTrigger = changes.refreshTrigger.currentValue;
    }

    if ( this.refreshTrigger ) {
      this.getTopNDevices();
    }
  }

  getHeaderQueryParams() {
    const headerQueryParams = {};
    if ( this.timeInterval !== undefined && this.timeInterval != null ) {
      headerQueryParams['time'] = this.timeInterval;
    } else {
      headerQueryParams['time'] = '336';
    }
    if ( this.deviceSet !== undefined && this.deviceSet != null ) {
      headerQueryParams['deviceSetId'] = this.deviceSet.id.toString();
    }
    headerQueryParams['deviceId'] =  this.headerTopNList;

    return headerQueryParams;
  }

  public getTopNDevices() {
    this.topNList = null;
    const selectedOrg = SelectedOrgMethod.getSelectedOrg(this.selectedOrgId);

    let deviceSetId = null;
    if ( this.deviceSet !== undefined && this.deviceSet != null) {
      deviceSetId = this.deviceSet.id;
    }
    const queryJson = {
      'time': this.timeInterval,
      'deviceSet': deviceSetId,
      'n': 5,
      'selectedOrgId': selectedOrg,
    };

    this.d3eService.getTopNDevices(queryJson)
        .pipe(untilDestroyed(this))
        .subscribe(results => {
            const newTopNList: TopNType[] = [];
            let newHeaderTopNList = '';
            results.forEach(element => {
                const historyParams = {};
                historyParams['time'] = this.timeInterval;
                if ( deviceSetId != null) {
                  historyParams['deviceSetId'] = deviceSetId.toString();
                }
                historyParams['deviceId'] = element['uuid'];

                const newTopN: TopNType = {
                  'id': element['uuid'],
                  'name': element['device_name'],
                  'threatCount': element['threat_count'],
                  'historyParams': historyParams
                };
                newTopNList.push(newTopN);
                newHeaderTopNList += element['uuid'] + ',';
            });
            this.topNList = newTopNList;
            this.headerTopNList = newHeaderTopNList;
    });
  }
}
